import React, { PureComponent } from 'react'
import { FormattedMessage } from 'react-intl'

import config from '../../../../../../../../config'

import { LOCALE_PREFIX } from './constants'

import './style.scss'

import groupIcon from '../../../../../../../../assets/modules/portfolio/empty/group-icon.png'
import helpGif from '../../../../../../../../assets/modules/portfolio/empty/help.gif'

const MODULE_NAME = config.modules.portfolio.key

export default class Empty extends PureComponent {
    render() {
        return (
            <div className={`workspace-${MODULE_NAME}-empty`}>
                <div className={'group-icon'}>
                    <img src={groupIcon} alt={'group icon'} />
                </div>
                <div className={'title'}>
                    <FormattedMessage id={`${LOCALE_PREFIX}.title`} />
                </div>
                <div className={'subtitle'}>
                    <FormattedMessage id={`${LOCALE_PREFIX}.subtitle`} />
                </div>
                <div className={'help-gif'}>
                    <img src={helpGif} alt={'help'} />
                </div>
            </div>
        )
    }
}
